module.exports = __webpack_public_path__ + "img/hr-wooden-particle-25.5f942865.png";